module.exports = __webpack_public_path__ + "img/编组 19@2x.db002610.png";